require('./alertify.min.css');
const alertify = require('./alertify.min.js');

export default alertify;


// WEBPACK FOOTER //
// ./uPortal/Content/js/Plugins/AlertifyJS/index.js